package com.essntl.features.message.domain.model

data class LinkPreviewModel(
    val body: String,
    val url: String,
)
